import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { authEvents, userEvents } from '../../utils/analytics';
import { formatEpochDate } from '../../utils/dateUtils';
import './Profile.css';

function ProfileInfo() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const handleLogout = async () => {
    try {
      await logout();
      authEvents.logout();
      userEvents.buttonClick('logout', 'profile');
      navigate('/');
    } catch (error) {
      userEvents.error('logout', error.message);
    }
  };
  return (
    <div className="profile component-card">
      <h2>Profile Information</h2>
      <div className="profile-info">
        <div className="info-item">
          <label>Email:</label>
          <span>{user.email}</span>
        </div>
        <div className="info-item">
          <label>Member Since:</label>
          <span>{formatEpochDate(user.created_at)}</span>
        </div>
      </div>
      
      <div className="account-actions">
        <button 
          onClick={handleLogout}
          className="logout-button"
        >
          Sign Out
        </button>
      </div>
    </div>
  );
}

export default ProfileInfo;
